import React, { useEffect } from "react";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, SEO, TrainingInfo } from "..";

export const BTAdult = () => {
  const checkServices = useStore((state) => state.checkServices);
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const trainingDetails = useStore((state) => state.trainingDetails);
  const btAdultPrograms = useStore((state) => state.btAdultPrograms);

  useEffect(() => {
    checkServices(trainingDetails);
  }, []);
  const overlay = {
    where: "btAdult",
    title: "Board and Train for Adult Dogs",
    caption:
      "Chico (or Chester?) shows off his loose leash walking skills with a gentle leader.",
  };
  const info = {
    routes: {
      Home: "/",
      Training: getLink(pathTitles.TRAINING),
      "Board And Train": getLink(pathTitles.BOARDANDTRAIN),
      "Board And Train for Adult Dogs": getLink(pathTitles.BOARDANDTRAINADULT),
    },
    body: trainingDetails.BOARDANDTRAINADULT.body,
    programs: btAdultPrograms,
  };
  return (
    <>
      <SEO
        title="Board and Train for Adult Dogs"
        description="Board & Train for adult dogs addressing reactivity, obedience, leash manners, and everyday behavior challenges. Full-immersion professional training in Indianapolis."
        path="/training/board-and-train-adult"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <TrainingInfo info={info} />
        </>
      )}
    </>
  );
};
